var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{on:{"enter":_vm.expand,"leave":_vm.collapse}},[_c('div',{staticClass:"generic-reveally-thing",attrs:{"data-fully-expanded":_vm.fullyExpanded}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }